// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  margin-top: 2%;
}
.card * {
  font-size: 14px;
}

.fs-12, .uploadedDate {
  font-size: 12px;
}

.text-right {
  text-align: right !important;
}

.cert-name {
  font-weight: bold;
  font-size: 20px !important;
}

.action-icons {
  height: 16px;
  width: 16px;
  margin-right: 2%;
  cursor: pointer;
}

.copy-button {
  cursor: pointer;
}
.copy-button:hover {
  color: cornflowerblue;
}

.bg-custom {
  font-size: 14px !important;
  background-color: #f1eeff !important;
  color: #6f63d6 !important;
}

.sign-reason {
  color: grey;
}

.card {
  border: none !important;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/signature/index.scss"],"names":[],"mappings":"AAAA;EACI,iDAAA;EACA,cAAA;AACJ;AACI;EACI,eAAA;AACR;;AAGA;EACI,eAAA;AAAJ;;AAOA;EACI,4BAAA;AAJJ;;AAOA;EACI,iBAAA;EACA,0BAAA;AAJJ;;AAOA;EACI,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,eAAA;AAJJ;AAMI;EACI,qBAAA;AAJR;;AAQA;EACI,0BAAA;EACA,oCAAA;EACA,yBAAA;AALJ;;AAQA;EACI,WAAA;AALJ;;AAQA;EACI,uBAAA;EACA,sDAAA;AALJ","sourcesContent":[".card {\n    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n    margin-top: 2%;\n\n    * {\n        font-size: 14px;\n    }\n}\n\n.fs-12 {\n    font-size: 12px;\n}\n\n.uploadedDate {\n    @extend .fs-12;\n}\n\n.text-right {\n    text-align: right !important;\n}\n\n.cert-name {\n    font-weight: bold;\n    font-size: 20px !important;\n}\n\n.action-icons {\n    height: 16px;\n    width: 16px;\n    margin-right: 2%;\n    cursor: pointer;\n}\n\n.copy-button {\n    cursor: pointer;\n\n    &:hover {\n        color: cornflowerblue;\n    }\n}\n\n.bg-custom {\n    font-size: 14px !important;\n    background-color: #f1eeff !important;\n    color: #6f63d6 !important;\n}\n\n.sign-reason {\n    color: grey;\n}\n\n.card {\n    border: none !important;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
